export const MAP_ENTITIES_LOADER = 'map-entities-loader';
export const CREATE_MAP_QUICK_ENTITY_LOADER = 'create-map-quick-entity-loader';
